/**
 * The namespace for SVG elements.
 */
export const XML_NAME_SPACE = 'http://www.w3.org/2000/svg';

/**
 * The arrow path.
 */
export const PATH = 'm15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z';

/**
 * SVG width and height.
 */
export const SIZE = 40;
